export const getters = {
	plans: state => state.plans,
	plan: state => id => { return state.plans.filter(o => (parseInt(o.id) === parseInt(id)))[0] }
}



// WEBPACK FOOTER //
// ./src/common/store/Plans/getters.js